import { Message } from "Models/message";

export const getLog = (state: any, uid: string): Message[] =>
    state.logs?.[uid] ?? [];

export const getLogs = (state: any): Message[][] =>
    state.logs ? Object.values(state.logs) : [];
